/*
 * ERP search for the Black & Blanc storefront.
 *
 *  - Header box: as the shopper types, live suggestions from the ERP (spelling forgiven,
 *    budgets like "under 500", colours, occasions, Arabic). Tapping the empty box shows
 *    popular searches and the shopper's own recent ones (kept on their device only).
 *  - Search page: when the shop is in AED, the ERP's ranking replaces Shopify's list
 *    (best sellers first, resting products last). Anything else — another currency, the
 *    ERP slow or down — leaves Shopify's own results exactly as they were.
 *  - No results: popular searches plus a WhatsApp link with the words pre-filled.
 *  - Logging: the words, how many results, which product was clicked, and Shopify's
 *    browser id. Never a name, phone or email.
 */
(function () {
  var C = window.ErpSearch;
  if (!C || !window.fetch) return;
  var AED = C.currency === "AED";
  var RECENT_KEY = "erpSearchRecent";
  var LOG = C.endpoint + "/log";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // "Amethyst – Purple Roses…" → name on top, what it is underneath (matches
  // snippets/product-title-split.liquid). Only an EN DASH with spaces splits.
  function titleHtml(t) {
    t = String(t || "");
    var k = t.indexOf(" \u2013 ");
    if (k < 1) return esc(t);
    return '<span class="bb-title__name">' + esc(t.slice(0, k)) + '</span><span class="bb-title__desc">' + esc(t.slice(k + 3).trim()) + "</span>";
  }
  function clientId() {
    var m = document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]+)/);
    return m ? decodeURIComponent(m[1]).slice(0, 80) : null;
  }
  function log(kind, q, extra) {
    q = (q || "").trim();
    if (!q) return;
    var body = { b: C.brand, k: kind, q: q.slice(0, 200), c: clientId() };
    for (var k in extra || {}) body[k] = extra[k];
    var data = JSON.stringify(body);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(LOG, new Blob([data], { type: "text/plain" }))) return;
    } catch (e) {}
    fetch(LOG, { method: "POST", body: data, headers: { "content-type": "text/plain" }, keepalive: true }).catch(function () {});
  }
  function getJSON(params, ms) {
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, ms || 4000);
    var qs = Object.keys(params).map(function (k) { return k + "=" + encodeURIComponent(params[k]); }).join("&");
    return fetch(C.endpoint + "?brand=" + C.brand + "&" + qs, { signal: ctl ? ctl.signal : undefined })
      .then(function (r) { clearTimeout(t); if (!r.ok) throw new Error(r.status); return r.json(); })
      .catch(function (e) { clearTimeout(t); throw e; });
  }
  // The shop carries some products twice (same name, same price, two pages). Show one.
  function uniqueProducts(list) {
    var seen = {};
    return list.filter(function (p) {
      var k = String(p.title || "").trim().toLowerCase() + "|" + p.price;
      if (seen[k]) return false;
      seen[k] = true;
      return true;
    });
  }
  function productUrl(handle) { return C.root + "products/" + handle; }
  function searchUrl(q) { return C.searchUrl + "?q=" + encodeURIComponent(q) + "&options%5Bprefix%5D=last"; }
  function price(p) {
    if (p == null) return "";
    var n = Math.round(p).toLocaleString("en-US");
    // Arabic pages show the amount then د.إ (snippets/bnb-rtl.liquid); English unchanged.
    return document.documentElement.lang === "ar" ? n + " د.إ" : "AED " + n;
  }

  // --- Recent searches (this device only) -------------------------------------------
  function recent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]").slice(0, 5); } catch (e) { return []; }
  }
  function remember(q) {
    q = (q || "").trim();
    if (!q) return;
    try {
      var list = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      list.unshift(q.slice(0, 60));
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 5)));
    } catch (e) {}
  }

  var popularP = null;
  function popular() {
    if (!popularP) popularP = getJSON({ popular: 1 }, 3000).then(function (r) { return ["Scorpio", "Autumn", "Birthday", "Red roses", "Orchids", "Infinity roses", "Anniversary", "Flowers and cake"]; }).catch(function () { return []; });
    return popularP;
  }
  function chips(list, label) {
    if (!list.length) return "";
    return '<p class="erp-suggest__label">' + esc(label) + '</p><ul class="erp-chips">' +
      list.map(function (q) { return '<li><a class="erp-chip" href="' + esc(searchUrl(q)) + '" data-erp-chip="' + esc(q) + '">' + esc(q) + "</a></li>"; }).join("") +
      "</ul>";
  }
  function noteFor(i) {
    if (!i) return "";
    var bits = [];
    if (i.corrected) bits.push("Showing results for <strong>" + esc(i.corrected) + "</strong>");
    if (i.min != null && i.max != null) bits.push("AED " + i.min + "–" + i.max);
    else if (i.max != null) bits.push("under AED " + i.max);
    else if (i.min != null) bits.push("over AED " + i.min);
    if (i.relaxed) bits.push("nothing had every word, so these are the closest");
    return bits.length ? '<p class="erp-note">' + bits.join(" · ") + "</p>" : "";
  }

  // --- Header suggestions ------------------------------------------------------------
  function initHeader() {
    var form = document.getElementById("HeaderSearchForm");
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    var container = form.closest(".site-header__search-container") || form.parentNode;
    if (!input || !container) return;
    var box = document.createElement("div");
    box.className = "erp-suggest";
    box.hidden = true;
    box.innerHTML = '<div class="page-width erp-suggest__inner"></div>';
    // The theme already positions this container (absolute, visible when open); never touch it.
    container.appendChild(box);
    var inner = box.firstChild;
    var timer = null, seq = 0, showing = false;

    function show(html) {
      inner.innerHTML = html;
      box.hidden = !html;
      showing = !!html;
      // While our search answers, Shopify's own box stays hidden — by a CSS class on <html>,
      // never by editing its classes (the theme's script edits them; a watcher is a loop).
      // Closing OUR box must not reveal theirs: it fills in the background as you type.
      if (html) handover(true);
    }
    function hide() {
      box.hidden = true;
      showing = false;
    }
    // On = ours is in charge (Shopify's box hidden). Off = the ERP failed; theirs comes back.
    function handover(on) {
      document.documentElement.classList.toggle("erp-search-active", on);
    }

    function empty() {
      popular().then(function (pop) {
        if (input.value.trim()) return;
        show(chips(recent(), "Your recent searches") + chips(pop, "Popular searches"));
      });
    }
    function live(q) {
      var mine = ++seq;
      getJSON({ q: q, live: 1, limit: 12 }, 2500)
        .then(function (r) {
          if (mine !== seq || input.value.trim() !== q) return;
          if (r.unavailable) { hide(); handover(false); return; }
          if (!r.products || !r.products.length) {
            hide(); handover(false);
            return;
          }
          show(
            noteFor(r.interpreted) +
              '<ul class="erp-suggest__list">' +
              uniqueProducts(r.products).slice(0, 6).map(function (p) {
                return '<li class="erp-suggest__item"><a href="' + esc(productUrl(p.handle)) + '" data-erp-click="' + esc(p.handle) + '">' +
                  '<span class="erp-suggest__img">' + (p.image ? '<img src="' + esc(p.image) + (p.image.indexOf("?") > -1 ? "&" : "?") + 'width=400" alt="" loading="lazy">' : "") + "</span>" +
                  '<span class="erp-suggest__text"><span class="erp-suggest__title">' + titleHtml(p.title) + "</span>" +
                  // A resting (off-season) product never shows a price — only that it is coming back.
                  (p.resting
                    ? '<span class="erp-suggest__price">Returns next season</span>'
                    : AED ? '<span class="erp-suggest__price">' + esc(price(p.price)) + "</span>" : "") +
                  "</span></a></li>";
              }).join("") +
              "</ul>" +
              '<a class="erp-suggest__all" href="' + esc(searchUrl(q)) + '">See all ' + r.total + " results</a>"
          );
        })
        .catch(function () { hide(); handover(false); }); // ERP down: Shopify's own suggestions carry on
    }

    input.addEventListener("focus", function () {
      if (!input.value.trim()) empty();
      else if (inner.innerHTML) { box.hidden = false; showing = true; } // back to what they typed
    });
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (!q) { empty(); return; }
      if (q.length < 2) return;
      timer = setTimeout(function () { live(q); }, 180);
    });
    box.addEventListener("click", function (e) {
      var a = e.target.closest("a");
      if (!a) return;
      var h = a.getAttribute("data-erp-click");
      var chip = a.getAttribute("data-erp-chip");
      if (h) { remember(input.value); log("click", input.value, { h: h, s: "suggest" }); }
      if (chip) remember(chip);
    });
    form.addEventListener("submit", function () { remember(input.value); log("submit", input.value, { s: "header" }); });
    // Clicking the page closes the WHOLE search bar, exactly as the X does — not just our box.
    // The search icon that opens it is excluded, or opening it would close it on the same click.
    function closeSearch() {
      hide();
      var x = document.getElementById("SearchClose");
      if (x && container.classList.contains("is-active")) x.click();
    }
    document.addEventListener("click", function (e) {
      if (container.contains(e.target)) return;
      if (e.target.closest && e.target.closest(".js-search-header")) return;
      if (showing || container.classList.contains("is-active")) closeSearch();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeSearch(); });
  }

  // --- Search page --------------------------------------------------------------------
  function emptyBlock(q) {
    var wa = "https://wa.me/" + encodeURIComponent(C.whatsapp) + "?text=" +
      encodeURIComponent("Hi, I was looking for " + q + " on your website. Can you help?");
    return popular().then(function (pop) {
      return '<div class="erp-empty"><p>We couldn’t find “' + esc(q) + '”.</p>' +
        '<p><a class="btn" href="' + esc(wa) + '" target="_blank" rel="noopener">Ask us on WhatsApp</a></p>' +
        chips(pop, "Try one of these") + "</div>";
    });
  }
  function initPage() {
    var q = (C.terms || "").replace(/\*/g, "").trim();
    var mount = document.getElementById("ErpSearchResults");
    if (!mount || !q) return;
    var nativeWrap = document.getElementById("NativeSearchResults");
    var pageForm = document.querySelector(".search-bar--page form, form.search-bar--page");
    if (pageForm) pageForm.addEventListener("submit", function () {
      var i = pageForm.querySelector('input[name="q"]');
      if (i) { remember(i.value); log("submit", i.value, { s: "page" }); }
    });
    remember(q);

    function nativeEmpty() {
      log("results", q, { rn: C.nativeCount });
      if (C.nativeCount === 0) emptyBlock(q).then(function (html) { mount.innerHTML = html; mount.hidden = false; });
    }
    if (!AED) { nativeEmpty(); return; }

    getJSON({ q: q, limit: 48 }, 4000)
      .then(function (r) {
        if (r.unavailable || (C.nativeCount > 0 && (!r.products || !r.products.length))) { nativeEmpty(); return; }
        log("results", q, { rn: C.nativeCount, ro: r.total || 0 });
        if (!r.products || !r.products.length) {
          return emptyBlock(q).then(function (html) {
            mount.innerHTML = html;
            mount.hidden = false;
            if (nativeWrap) nativeWrap.hidden = true;
          });
        }
        mount.innerHTML =
          noteFor(r.interpreted) +
          '<ul class="erp-results">' +
          uniqueProducts(r.products).map(function (p) {
            return '<li class="erp-card"><a href="' + esc(productUrl(p.handle)) + '" data-erp-click="' + esc(p.handle) + '">' +
              '<div class="erp-card__img">' + (p.image ? '<img src="' + esc(p.image) + (p.image.indexOf("?") > -1 ? "&" : "?") + 'width=600" alt="' + esc(p.title) + '" loading="lazy">' : "") + "</div>" +
              '<div class="erp-card__title">' + titleHtml(p.title) + "</div>" +
              (p.resting ? "" : '<div class="erp-card__price">' + esc(price(p.price)) + "</div>") +
              (p.resting ? '<div class="erp-card__tag">Returns next season</div>' : "") +
              "</a></li>";
          }).join("") +
          "</ul>";
        mount.hidden = false;
        if (nativeWrap) nativeWrap.hidden = true;
        mount.addEventListener("click", function (e) {
          var a = e.target.closest("a[data-erp-click]");
          if (a) log("click", q, { h: a.getAttribute("data-erp-click"), s: "results" });
        });
      })
      .catch(function () { nativeEmpty(); }); // leave Shopify's results as they are
  }

  function start() { initHeader(); initPage(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
